import api from "../../../core/api";
import {
  ConfirmInvite,
  ConfirmInviteResult,
  ConfirmRegister,
  ConfirmRegisterResult,
  ConfirmInviteForm,
  Customer,
  Register,
  Registration,
  AccountUserInfo,
  UpdateAccount,
  ChangePassword
} from "../models/customerModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class AdminUsersApi {
  register(model: Register): Promise<void> {
    return api.post(`/v1/account/register`, model, getRequestConfig());
  }

  getRegistration(userId: string): Promise<Registration> {
    return api.get<Registration>(`/v1/account/register/${userId}`, getRequestConfig())
      .then(x => x.data);
  }

  confirmInviteForm(userId: string, token: string): Promise<ConfirmInviteForm> {
    return api.get<ConfirmInviteForm>(`/v1/account/confirm-invite?userId=${encodeURIComponent(userId)}&token=${encodeURIComponent(token)}`, getRequestConfig())
      .then(x => x.data);
  }

  confirmRegister(model: ConfirmRegister): Promise<ConfirmRegisterResult> {
    return api.post<ConfirmRegisterResult>(`/v1/account/confirm-register`, model, getRequestConfig())
      .then(x => x.data);
  }

  confirmInvite(model: ConfirmInvite): Promise<ConfirmInviteResult> {
    return api.post<ConfirmInviteResult>(`/v1/account/confirm-invite`, model, getRequestConfig())
      .then(x => x.data);
  }

  getCustomer(): Promise<Customer> {
    return api.get<Customer>(`/v1/customers/home`, getRequestConfig())
      .then(x => x.data);
  }

  getAccount(): Promise<AccountUserInfo> {
    return api.get<AccountUserInfo>(`/v1/account`, getRequestConfig())
      .then(x => x.data);
  }

  updateAccount(model: UpdateAccount): Promise<void> {
    return api.put<void>(`/v1/account`, model, getRequestConfig()).then(() => { });
  }

  updateFontTheme(fontTheme: string): Promise<void> {
    return api.patch<void>(`/v1/account/font-theme`, { fontTheme }).then(() => { });
  }

  getFontTheme(): Promise<string | null> {
    return api.get<AccountUserInfo>(`/v1/account`, getRequestConfig())
      .then(x => x.data?.fontTheme || null)
      .catch(() => null);
  }

  getAccentTheme(): Promise<string | null> {
    return api.get<AccountUserInfo>(`/v1/account`, getRequestConfig())
      .then(x => x.data?.accentTheme || null)
      .catch(() => null);
  }

  updateAccentTheme(accentTheme: string): Promise<void> {
    return api.patch<void>(`/v1/account/accent-theme`, { accentTheme }).then(() => { });
  }

  updateLanguage(language: string): Promise<void> {
    return api.patch<void>(`/v1/account/language`, { language }).then(() => { });
  }

  getLanguageId(): Promise<number | null> {
    return api.get<AccountUserInfo>(`/v1/account`, getRequestConfig())
      .then(x => x.data?.languageId || null)
      .catch(() => null);
  }

  changePassword(model: ChangePassword): Promise<void> {
    return api.post<void>(`/v1/account/change-password`, model, getRequestConfig()).then(() => { });
  }
}

export default new AdminUsersApi();